import {
  collection,
  doc,
  setDoc,
  deleteDoc,
  onSnapshot,
  serverTimestamp,
  type Unsubscribe,
} from 'firebase/firestore';
import { db } from '@/lib/firebase';
import { useHabitStore } from '@/stores/habitStore';
import type { HabitCompletion } from '@/types';
import { toDate } from './firestoreDate';
import { logSyncError } from './syncErrors';

function completionsCol(uid: string) {
  return collection(db, 'users', uid, 'completions');
}

export function startCompletionSync(uid: string): Unsubscribe {
  return onSnapshot(
    completionsCol(uid),
    (snap) => {
      const completions: HabitCompletion[] = snap.docs.map((d) => {
        const data = d.data();
        const completion: HabitCompletion = {
          id: d.id,
          habitId: data.habitId as string,
          date: data.date as string,
          completedAt: toDate(data.completedAt),
        };

        if (data.note !== undefined) completion.note = data.note as string;

        return completion;
      });
      useHabitStore.setState({ completions });
    },
    logSyncError('completionSync', uid),
  );
}

export async function writeCompletion(uid: string, completion: HabitCompletion): Promise<void> {
  const { id, ...rest } = completion;
  await setDoc(doc(completionsCol(uid), id), { ...rest, serverUpdatedAt: serverTimestamp() });
}

export async function deleteCompletion(uid: string, completionId: string): Promise<void> {
  await deleteDoc(doc(completionsCol(uid), completionId));
}
